/* cjl-wishlist — favoritos sin app (tanda 1 · 4 oct).
   Lista de handles en localStorage ('cjl-wishlist'): vive solo en ese navegador.
   Hace tres cosas: corazones en las cards ([data-cjl-wish]), corazón con contador en el
   header (inyectado junto al carrito) y el pintado de la página /pages/wishlist
   (sections/cjl-wishlist.liquid). El "Add" de la página reutiliza el quick add de
   cjl-collection.js (.cjl-card__quickadd → cart/add.js → drawer). */
(function () {
  'use strict';
  var KEY = 'cjl-wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3 4.6 13a4.8 4.8 0 0 1 0-6.9 5 5 0 0 1 7 0l.4.4.4-.4a5 5 0 0 1 7 0 4.8 4.8 0 0 1 0 6.9z"/></svg>';

  function list() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
  }
  function toggle(h) {
    var l = list(), i = l.indexOf(h);
    if (i === -1) l.unshift(h); else l.splice(i, 1);
    save(l); paint();
    return i === -1;
  }

  function paint() {
    var l = list();
    var hearts = document.querySelectorAll('[data-cjl-wish]');
    for (var i = 0; i < hearts.length; i++) {
      var on = l.indexOf(hearts[i].getAttribute('data-cjl-wish')) !== -1;
      hearts[i].classList.toggle('is-on', on);
      hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    /* sin contador (owner 4 oct): solo contorno vacío / rojo lleno */
    var head = document.querySelector('.cjl-wl-head');
    if (head) head.classList.toggle('has-items', l.length > 0);
  }

  /* corazón del header: antes del enlace del carrito de Eurus (si no lo encuentra, no pasa nada) */
  function mountHead() {
    if (document.querySelector('.cjl-wl-head')) return;
    var cart = document.querySelector('header a[href*="/cart"], .shopify-section-group-header-group a[href*="/cart"]');
    if (!cart) return;
    var a = document.createElement('a');
    a.className = 'cjl-wl-head';
    a.href = root + 'pages/wishlist';
    a.setAttribute('aria-label', 'My wishlist');
    a.innerHTML = HEART;
    cart.parentNode.insertBefore(a, cart);
    clearSearch(a);
    window.addEventListener('resize', function () { clearSearch(a); });
  }

  /* La lupa de Eurus es un <a> absoluto sobre una caja de ancho 0 (mobile-center-left):
     se dibuja ENCIMA del hueco donde entra el corazón. Medimos el choque real y
     apartamos el corazón hacia la izquierda justo lo necesario. */
  function clearSearch(a) {
    requestAnimationFrame(function () {
      a.style.marginRight = '';
      var lens = document.querySelector('.x-header-icon-search a');
      if (!lens) return;
      var lr = lens.getBoundingClientRect();
      var hr = a.getBoundingClientRect();
      if (!lr.width || !hr.width) return;
      var overlap = Math.min(hr.right, lr.right) - Math.max(hr.left, lr.left);
      if (overlap > 0) a.style.marginRight = Math.ceil(overlap + 6) + 'px';
    });
  }

  /* clic en cualquier corazón (las cards son <a>: se corta la navegación, como el quick add) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cjl-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(btn.getAttribute('data-cjl-wish'));
    if (on && btn.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 300 });
    }
    if (!on && btn.closest('[data-cjl-wl-grid]')) render(); /* en la página, quitar = sale de la lista */
  }, true);

  /* ---- página My Wishlist ---- */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function render() {
    var grid = document.querySelector('[data-cjl-wl-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-cjl-wl-empty]');
    var l = list();
    grid.hidden = l.length === 0;
    if (empty) empty.hidden = l.length > 0;
    if (!l.length) { grid.innerHTML = ''; return; }
    Promise.all(l.map(function (h) {
      return fetch(root + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      grid.innerHTML = ps.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
        return '<div class="cjl-wl__card">' +
          '<button type="button" class="cjl-wl__remove" data-cjl-wish="' + p.handle + '" aria-label="Remove ' + p.title + '">&#10005;</button>' +
          '<a class="cjl-wl__media" href="' + root + 'products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="cjl-wl__name" href="' + root + 'products/' + p.handle + '">' + p.title + '</a>' +
          '<span class="cjl-wl__price">' + money(p.price) + '</span>' +
          (p.available
            ? '<button type="button" class="cjl-card__quickadd cjl-wl__add" data-cjl-atc="' + p.variants[0].id + '">Add &mdash; ' + money(p.price) + '</button>'
            : '<span class="cjl-wl__soldout">Sold out</span>') +
          '</div>';
      }).join('');
      paint();
    });
  }

  function boot() { mountHead(); paint(); render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { mountHead(); paint(); });
})();
